import { render, staticRenderFns } from "./ZCzichanchuzulv2.vue?vue&type=template&id=1cfdb928&scoped=true"
import script from "./ZCzichanchuzulv2.vue?vue&type=script&lang=js"
export * from "./ZCzichanchuzulv2.vue?vue&type=script&lang=js"
import style0 from "./ZCzichanchuzulv2.vue?vue&type=style&index=0&id=1cfdb928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfdb928",
  null
  
)

export default component.exports